// removed by extract-text-webpack-plugin
module.exports = {"Admin":"src-App-pages-Home-pages-Admin-index__Admin--2L_sA","Admin-button":"src-App-pages-Home-pages-Admin-index__Admin-button--1A_Ov"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Admin/index.scss
// module id = 787
// module chunks = 0